import {mousemove} from "./debug.js";
import {getDevice} from "../../../commonjs/device.js";
import {google} from "../../../commonjs/google.js";
import {load_off} from "../../../commonjs/load.js";

import "../../../commoncss/loading.css";
import "./works.css";
import "../../../commoncss/pc_menu.css";
import "../../../commoncss/link.css";

import "@babel/polyfill";//promise　やarrayfromも変換


window.onload = function(){
    //mousemove();
    load_off();
    google();
    const work = Array.from(document.getElementsByClassName(`work`));
    const length_of_arts = parseFloat(document.getElementsByClassName(`work`).length);
    const img_url = `image/dist/main/`;
    const device = getDevice();
    /*====================PC slideshow===================*/
    const light_box = document.getElementById(`light_box`);
    const right = document.getElementById(`right`);
    const left = document.getElementById(`left`);
    const slide = document.getElementsByClassName(`slide`)[0];
    const adjust = document.getElementById(`adjust`);
    const plus = document.getElementById(`plus`);
    const minus = document.getElementById(`minus`);
    const close = document.getElementById(`close`);
    
    const mytap = window.ontouchstart===null?`touchstart`:`click`;
    console.log(window.ontouchstart===null);
    
    class Slide_base{
        
        constructor(){
            this.device = device;
            right.addEventListener(mytap,this.click_allow);
            left.addEventListener(mytap,this.click_allow);
        }
        
        click_allow(e){
            this.elm = e.target.id;
            const fade_out = slide.animate({opacity:[1,0]},{
                    direction: `alternate`,
                    duration: 500,
                    fill:`forwards`,
            });
            
            fade_out.addEventListener(`finish`,()=>{
                slide.style.top = ``;
                slide.style.left = ``;
                slide.style.height = ``;
                let img_num = parseFloat(slide.dataset.img);
                console.log(img_num);
                if(this.elm === `right`){
                    img_num++;
                    if(img_num > length_of_arts){
                        img_num = 1;
                    }
                } else if (this.elm === `left`){
                    img_num--;
                    if(img_num < 1){
                        img_num = length_of_arts;
                    }
                }
                console.log(img_num);
                slide.dataset.img = img_num;
                slide.src = img_url + slide.dataset.title + String(img_num).padStart(2,`0`) + `.jpg`;
                
                slide.animate({opacity:[0,1]},{
                    direction: `alternate`,
                    duration: 500,
                    fill:`forwards`,
                });
                
            });
        }
        
        
        
        scale(button,present_scale){
            present_scale = parseFloat(present_scale);
            const ratio = 10;
            if(button=== `minus`&& present_scale > 80){
                present_scale -= ratio;
            }
            
            else if(button ===`plus` && present_scale < 120){
                present_scale += ratio;
            }else{
                
            }
            return present_scale;
        }
        
    }
    
    function mode_position(begin,client,position){
                const mouse_p = parseFloat(client) - parseFloat(begin);
                return (mouse_p + parseFloat(position)) + `px`;
    }
    
    
    slide.dataset.ratio = 1;
    class Mobile_slide extends Slide_base{
        
        constructor(){    
            super();
            if(device !== `device`){
                return;
            }
            this.closing();
            slide.addEventListener(`touchstart`,(e)=>{
                console.log(e.touches.length);
				const finger = parseFloat(e.touches.length);
                e.preventDefault();
                if(finger>1){
                    slide.dataset.size = document.defaultView.getComputedStyle(slide,null).height;
                    slide.dataset.begin = this.finger_position(e);
                    slide.addEventListener(`touchmove`,this.touch_zoom);
                    slide.addEventListener(`touchend`,(e)=>{
                        slide.removeEventListener(`touchmove`,this.touch_zoom);
                    });
                    
                }else if(finger==1){
                	slide.dataset.beginY = e.touches[0].clientY;
                	slide.dataset.beginX = e.touches[0].clientX;
                	slide.addEventListener(`touchmove`,this.touch_move);
                	slide.addEventListener(`touchend`,(e)=>{
                	   slide.removeEventListener(`touchmove`,this.touch_move); 
                	});
				}
                
                
            });
            
            
        }
        
        closing(){
            close.addEventListener(`touchstart`,(e)=>{
                    console.log(`launbch`);
                    close.animate([{width:`50px`},{width:`60px`}],{
                        direction: `alternate`,
                        duration: 1000,
                        fill:`forwards`,
                   });
        
                    
        
                    const fade_out = light_box.animate({opacity:[1,0]},{
                        direction: `alternate`,
                        duration: 1000,
                        fill:`forwards`,
                    });
                    fade_out.addEventListener(`finish`,()=>{
                        light_box.style.display = `none`;
                        slide.style.width = 'auto';
                        close.style.opacity = 1;
                        light_box.dataset.zoom = 100;
                        slide.style.top = ``;
                        slide.style.left = ``;
                        slide.style.height = ``;
                        
                        close.animate([{width:`70px`},{width:`50px`}],{
                            duration:20,
                            fill:`forwards`, 
                        });
                        [right,left].forEach(v=>{
                            v.animate({opacity:[1,0]},{
                                duration:50,
                                fill:`forwards`,
                            })
                        });
                    });
        
        });
        }
        
        
        touch_move(e){
            const style_top = document.defaultView.getComputedStyle(slide,null).top;
            const style_left = document.defaultView.getComputedStyle(slide,null).left;
                slide.style.top = mode_position(slide.dataset.beginY,
                                               e.touches[0].clientY,style_top);
                slide.style.left = mode_position(slide.dataset.beginX,
                                                e.touches[0].clientX,style_left);
                slide.dataset.beginX = parseFloat(e.touches[0].clientX);
                slide.dataset.beginY = parseFloat(e.touches[0].clientY);
        }
        
        touch_zoom(e){
			let ratio = parseFloat(slide.dataset.ratio);
			/*
            const style_top = document.defaultView.getComputedStyle(slide,null).top;
            const style_left = document.defaultView.getComputedStyle(slide,null).left;
			*/
			const finger_1 = Math.abs(parseFloat(e.touches[0].clientX) - parseFloat(e.touches[0].clientY));
            const finger_2 = Math.abs(parseFloat(e.touches[1].clientX) - parseFloat(e.touches[1].clientY));
            const present_position = finger_1 * finger_2;
            const sum = parseFloat(slide.dataset.begin) - present_position;
			if(sum<0){
                ratio *=1.02;
            }else if(sum>0){
                ratio *= 0.98;
            }
			
			if(ratio<0.7||ratio>1.5){
				return;
			}
            const inital = parseFloat(slide.dataset.initial_size);
            const slide_size = inital*ratio;
            slide.dataset.ratio = ratio;
			slide.dataset.begin = present_position;
            slide.style.height = slide_size + `px`;
        }
        
        finger_position(e){
            const finger_1 = Math.abs(parseFloat(e.touches[0].clientX) - parseFloat(e.touches[0].clientY));
            const finger_2 = Math.abs(parseFloat(e.touches[1].clientX) - parseFloat(e.touches[1].clientY));
            return finger_1 * finger_2;
        }
    }
    
    const mobile = new Mobile_slide();
    
    /*==============================mobile===============================*/
    
    function get_img_number(alt){
        console.log(alt);
        const file_path = alt.match(/[a-z]+[\d]{2}.jpg/);
        console.log(file_path);
        const title = file_path[0].match(/[a-z]+/);
        console.log(title);
        const num = alt.match(/\d{2}/ig)[0];
        return [img_url + file_path[0],parseFloat(num),title];
    }
    
    work.forEach((v)=>{
        v.addEventListener(mytap,(e)=>{
            e.preventDefault();
            console.log(e);
            
            light_box.style.display = `block`;
            slide.src = get_img_number(e.target.href)[0];
            slide.dataset.img = get_img_number(e.target.href)[1];
            slide.dataset.title = get_img_number(e.target.href)[2];
            /*img要素取得して画像変更*/
            
            const light = light_box.animate({opacity:[0,1]},{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
            
            [right,left].forEach(v=>{
                    v.animate({opacity:[0,1]},{
                        direction: `alternate`,
                        duration: 1000,
                        fill:`forwards`,
                        delay:500,
                    });
                });
			
			light.addEventListener(`finish`,()=>{//スライド表示後にサイズを調べる
				slide.dataset.initial_size = document.defaultView.getComputedStyle(slide,null).height;
			});
            
        });
    });
    
    
    
    
    class Slide_event extends Slide_base{
        constructor(){
            super();
            console.log(device);
            if(device !== `PC`){
                return;
            }
            this.light_box = light_box;
            this.zoom_in = plus;
            this.zoom_out = minus;
            this.zoom_in.addEventListener(`click`,(e)=>{
                this.elm = e.target.id;
                this.click_in();
            });
            
            this.zoom_out.addEventListener(`click`,(e)=>{
                this.elm = e.target.id;
                this.click_in();
            });
            
           
            
            close.addEventListener(`click`,(e)=>{
               const fade_out = light_box.animate({opacity:[1,0]},{
                    direction: `alternate`,
                    duration: 1000,
                    fill:`forwards`,
               });
                fade_out.addEventListener(`finish`,()=>{
                    light_box.style.display = `none`;
                    slide.style.top = ``;
                    slide.style.left = ``;
                    slide.style.width = 'auto';
                    slide.style.height = 100 +`%`;
                    light_box.dataset.zoom = 100;
                });
            });
            
            this.mouse_control();
        }
        
        click_in(){
            const zooming = parseFloat(light_box.dataset.zoom);
            const fade_out = slide.animate({opacity:[1,0]},{
                direction: `alternate`,
                duration: 500,
                fill:`forwards`,
            });
            const scale_size = this.scale(this.elm,zooming);
            light_box.dataset.zoom = scale_size;
            fade_out.addEventListener(`finish`,()=>{
                slide.style.height = scale_size + `%`;
                slide.style.top = ``;
                slide.style.left = ``;
                
                slide.animate({opacity:[0,1]},{
                    direction: `alternate`,
                    duration: 500,
                    fill:`forwards`,
                });
            });
        }
        
        mouse_control(){
            slide.addEventListener(`mousedown`,mouse_down);
            function mouse_down(e){
                e.preventDefault();
                slide.dataset.beginX = parseFloat(e.clientX);
                slide.dataset.beginY = parseFloat(e.clientY);
                console.log(slide.dataset.beginX);
                slide.addEventListener(`mousemove`,mouse_move);
                slide.addEventListener(`mouseup`,remove_event);
            }
            
            function mouse_move(e){
                const style_top = document.defaultView.getComputedStyle(slide,null).top;
                const style_left = document.defaultView.getComputedStyle(slide,null).left;
                slide.style.top = mode_position(slide.dataset.beginY,
                                               e.clientY,style_top);
                slide.style.left = mode_position(slide.dataset.beginX,
                                                e.clientX,style_left);
                slide.dataset.beginX = parseFloat(e.clientX);
                slide.dataset.beginY = parseFloat(e.clientY);
            }
            
            function remove_event(e){
                console.log(e);
                slide.removeEventListener(`mousemove`,mouse_move);
            }
            
        }
        
    }//end of object
    
    const slide_event = new Slide_event();
    
    
}